import React, { useEffect, useRef, useState } from "react";
import { videoInfosFromUrl } from "./utils";

interface VideoPlayerProps extends React.HTMLAttributes<HTMLDivElement> {
	source: string;
	space?: number;
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({ source, space, ...htmlProps }) => {
	const videoId = videoInfosFromUrl(source)?.videoId;
	const videoRef = useRef<HTMLDivElement>(null);
	const [isVisible, setIsVisible] = useState(false);
	const allowAutoplayRef = useRef(true);
	const hasBeenVisibleRef = useRef(false);
	// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
	const handleIntersection = (entries: IntersectionObserverEntry[]) => {
		const [entry] = entries;
		if (entry.isIntersecting) {
			hasBeenVisibleRef.current = true;
		} else if (hasBeenVisibleRef.current) {
			allowAutoplayRef.current = false;
		}
		setIsVisible(entry.isIntersecting);
	};
	useEffect(() => {
		const options = {
			root: null,
			rootMargin: "0px",
			threshold: 0.5,
		};
		const observer = new IntersectionObserver(handleIntersection, options);
		if (videoRef.current) {
			observer.observe(videoRef.current);
		}
		return () => {
			if (videoRef.current) {
				observer.unobserve(videoRef.current);
			}
		};
	}, [videoId]);

	return videoId !== undefined ? (
		<div
			{...htmlProps}
			ref={videoRef}
			style={{
				width: "100%",
				paddingTop: space ? `${space}%` : "56.25%",
				position: "relative",
			}}
		>
			<iframe
				src={`https://www.youtube.com/embed/${videoId}?rel=0&loop=1&playlist=${videoId}&modestbranding=1&autoplay=${
					isVisible && allowAutoplayRef.current ? 1 : 0
				}&mute=1`}
				style={{
					position: "absolute",
					top: "0",
				}}
				width={"100%"}
				height={"100%"}
				frameBorder={0}
				allowFullScreen
			/>
		</div>
	) : null;
};
